"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _MultipartUploadList_1 = require("./_MultipartUploadList");
var _CommonPrefixList_1 = require("./_CommonPrefixList");
exports.ListMultipartUploadsOutput = {
    type: "structure",
    required: [],
    members: {
        Bucket: {
            shape: {
                type: "string"
            }
        },
        KeyMarker: {
            shape: {
                type: "string"
            }
        },
        UploadIdMarker: {
            shape: {
                type: "string"
            }
        },
        NextKeyMarker: {
            shape: {
                type: "string"
            }
        },
        Prefix: {
            shape: {
                type: "string"
            }
        },
        Delimiter: {
            shape: {
                type: "string"
            }
        },
        NextUploadIdMarker: {
            shape: {
                type: "string"
            }
        },
        MaxUploads: {
            shape: {
                type: "integer"
            }
        },
        IsTruncated: {
            shape: {
                type: "boolean"
            }
        },
        Uploads: {
            shape: _MultipartUploadList_1._MultipartUploadList,
            locationName: "Upload"
        },
        CommonPrefixes: {
            shape: _CommonPrefixList_1._CommonPrefixList
        },
        EncodingType: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=ListMultipartUploadsOutput.js.map